<div
  class="stars"
  role="radiogroup"
  [attr.aria-readonly]="readonly"
  [style.--star-active-color]="starColor()"
>
  <button
    *ngFor="let starNumber of stars"
    type="button"
    role="radio"
    class="star"
    [class.filled]="isFilled(starNumber)"
    [disabled]="readonly"
    [attr.aria-label]="starAriaLabel(starNumber)"
    [attr.aria-checked]="isSelected(starNumber)"
    [attr.tabindex]="getStarTabIndex(starNumber)"
    (click)="onSelect(starNumber)"
  >
    ★
  </button>
</div>
